/**
 * KAN-952: where the "С чего начать" button sits next to the page tutorial
 * button, and how much room the content keeps at the bottom for both.
 *
 * - page button bottom-right: onboarding right above it;
 * - page button top-right (chat, input row at the bottom): onboarding is drawn
 *   inline in the row of the page button (OnboardingButton inline), so the
 *   "Отправить" button and the chat header stay free;
 * - no page button: onboarding bottom-right alone.
 */
import type { TutorialPlacement } from '@/tutorials/registry';

/** Fixed position of the standalone button (top-right pages use the inline one). */
export function onboardingPositionClass(pagePlacement: TutorialPlacement | undefined): string {
  return pagePlacement === 'bottom-right' ? 'bottom-24 right-6' : 'bottom-6 right-6';
}

/** Bottom padding class of the cabinet content, '' when nothing sits at the bottom. */
export function bottomGutterClass(
  pagePlacement: TutorialPlacement | undefined,
  onboardingShown: boolean
): string {
  if (pagePlacement === 'bottom-right') return onboardingShown ? 'pb-40' : 'pb-24';
  if (pagePlacement === undefined && onboardingShown) return 'pb-24';
  return '';
}
